import { Place } from "../models";

class Duty {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.id = jsonData.id;
		this.placeId = jsonData.placeId;
		this.date = jsonData.date;
		
		if (jsonData.place)
			this.place = new Place(jsonData.place);

	}

}

export { Duty };